// extracted by mini-css-extract-plugin
module.exports = {"search-summary":"SearchResultsSummary_search-summary__1lXMz","container":"SearchResultsSummary_container__1r8si","filters":"SearchResultsSummary_filters__15QyG"};